import React, { useEffect } from 'react';

import { Basic3dLayout } from '@/ui-kit';
import { embeddingService } from '@/ui-kit/services/embedding/EmbeddingService';
import { SheetRouterProvider } from '@/ui-kit/components/SheetRouter/SheetRouterContext';
import { BootstrapperProvider } from '@/ui-kit/contexts/BootstrapperContext';

import { ConfiguratorError } from '@/components/ConfiguratorError/ConfiguratorError';
import { LanguageFallbackNotice } from '@/localization/LanguageFallbackNotice';
import type { LanguageIssue } from '@/localization/languageFallback';

import { useConfigurator } from './ConfiguratorContext';

import style from './Configurator.module.css';

export function Configurator({
  loadConfigurationError,
  languageIssue = null,
}: {
  loadConfigurationError: { code: string; cause?: string } | null;
  languageIssue?: LanguageIssue | null;
}) {
  const configurator = useConfigurator();

  useEffect(() => {
    if (configurator) {
      embeddingService.sendReady();
    }
  }, [configurator]);

  return (
    <div className={configurator?.without3d ? style.rootNo3d : style.root} data-testid="configurator">
      {configurator && (
        <BootstrapperProvider {...configurator}>
          <LanguageFallbackNotice issue={languageIssue} />
          <SheetRouterProvider>
            <Basic3dLayout {...configurator} />
          </SheetRouterProvider>
        </BootstrapperProvider>
      )}
      {loadConfigurationError && (
        <ConfiguratorError errorCode={loadConfigurationError.code} causeMessage={loadConfigurationError.cause} />
      )}
    </div>
  );
}
